import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ClockIcon',
  props: {
  width: {
    type: [String, Number],
    default: 19,
  },
  height: {
    type: [String, Number],
    default: 19,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    fill: "none"
  }, _ctx.$attrs, {
    width: __props.width,
    height: __props.height
  }), [
    _createElementVNode("path", {
      d: "M9.5 0C12.0196 0 14.4359 1.00089 16.2175 2.78249C17.9991 4.56408 19 6.98044 19 9.5C19 12.0196 17.9991 14.4359 16.2175 16.2175C14.4359 17.9991 12.0196 19 9.5 19C6.98044 19 4.56408 17.9991 2.78249 16.2175C1.00089 14.4359 0 12.0196 0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0ZM8.90625 3.5625C8.74878 3.5625 8.59775 3.62506 8.4864 3.73641C8.37506 3.84776 8.3125 3.99878 8.3125 4.15625V10.0938L8.322 10.2006C8.34701 10.3373 8.41918 10.4609 8.52594 10.5499C8.6327 10.6388 8.76728 10.6875 8.90625 10.6875H12.4688L12.5756 10.678C12.7216 10.6516 12.8524 10.5714 12.9423 10.4534C13.0322 10.3353 13.0746 10.1879 13.0612 10.0401C13.0478 9.89233 12.9795 9.75494 12.8699 9.65498C12.7602 9.55502 12.6171 9.49973 12.4688 9.5H9.5V4.15625L9.4905 4.04937C9.46549 3.91268 9.39332 3.78908 9.28656 3.70012C9.1798 3.61115 9.04522 3.56245 8.90625 3.5625Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})